import { MInput, MSkeleton } from '@Components/Base';

import { useAppSelector } from '@Hooks/index';
import { useGetTenderDocumentsQuery } from '@Features/MaterialRequest/requests/TenderRequest/store/api/TenderRequestApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { getFileTypeExt } from '@Features/utils/document';

import { findTenderDocumentItemBySearchValue } from '@Features/MaterialRequest/requests/utils/finder';
import { useState, useCallback, useEffect } from 'react';
import { TenderGetDocumentResponse } from '@Types/api/form/tenderRequest/TenderGetDocumentResponse';
import { NoData } from '@Components/RequestList/noData';

import MaterialDocumentItem from './MaterialDocumentItem';

import styles from '../view-tab.module.css';

const DocumentsTab: React.FC = () => {
  const [searchValue, setSearchValue] = useState<string>();
  const tenderId = useAppSelector(getModalRecordKey);
  const { data: documents, isSuccess } = useGetTenderDocumentsQuery(tenderId, {
    skip: !tenderId,
  });
  const [searchedDocItems, setSearchedDocItems] =
    useState<Array<TenderGetDocumentResponse>>();

  useEffect(() => {
    if (documents?.length) {
      setSearchedDocItems(documents);
    }
  }, [documents]);

  const handleSearchDocItems = useCallback(
    (value: string) => {
      setSearchValue(value);
      if (documents) {
        const result = findTenderDocumentItemBySearchValue(documents, value);
        setSearchedDocItems(result);
      }
    },
    [documents]
  );

  const handleDownload = (url: string | undefined, filePath: string): void => {
    if (url) {
      const a = document.createElement('a');
      a.href = url;
      a.download = filePath;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  };

  return (
    <div className={styles.viewTabMaterials}>
      <MInput
        className={styles.search}
        value={searchValue}
        onChange={(event) => handleSearchDocItems(event.target.value)}
        searchInput
        placeholder="Search..."
      />
      {isSuccess ? (
        <div className={styles.container}>
          {searchedDocItems?.length ? (
            <>
              {searchedDocItems.map((document) => {
                return (
                  <MaterialDocumentItem
                    description={document.description}
                    name={document.documentName}
                    status={Boolean(document.isDeleted)}
                    type={getFileTypeExt(document.filePath)}
                    key={`${document.documentName}-${document.filePath}-${document.documentId}`}
                    isConfidential={Boolean(document.isConfidential)}
                    filePath={document.filePath}
                    documentId={document.documentExternalId}
                    onDownload={handleDownload}
                  />
                );
              })}
            </>
          ) : (
            <NoData context="documents" />
          )}
        </div>
      ) : (
        <div className={styles.container}>
          <MSkeleton repeat={2} className="skeleton-item" />
        </div>
      )}
    </div>
  );
};

export default DocumentsTab;
